import { render, staticRenderFns } from "./groups_list_with_filtered_search_app.vue?vue&type=template&id=141cb884"
import script from "./groups_list_with_filtered_search_app.vue?vue&type=script&lang=js"
export * from "./groups_list_with_filtered_search_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports